var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["form-row", _vm.show ? "" : "hide"] }, [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _vm._t("content_type"),
        _vm._v(" "),
        _vm._t("template"),
        _vm._v(" "),
        _vm._t("redirect_url"),
        _vm._v(" "),
        _vm._t("open_in_new_tab")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6 pl-sm-5" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-display-switches" },
          [
            _c("hr"),
            _vm._t("show_in_menu"),
            _vm._v(" "),
            _c("hr"),
            _vm._t("show_in_responsive_menu"),
            _vm._v(" "),
            _c("hr"),
            _vm._t("show_in_footer"),
            _c("hr")
          ],
          2
        ),
        _vm._v(" "),
        _vm._t("scopes")
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "form-group page-type-group",
        attrs: {
          role: "group",
          description:
            "Is this a regular page you want to add content to or a link that redirect to another page/site?"
        }
      },
      [
        _c("h3", [_vm._v("Assign to Menus")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "You can choose to show or hide your page from your site menus."
          )
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ad24644", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ad24644","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/PageDetailsWithScopesFormLayout.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8ad24644","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/PageDetailsWithScopesFormLayout.vue
// module chunks = 0